import _typeof from "@babel/runtime/helpers/typeof";
export var isSideText = function isSideText(side) {
  return !!(side && _typeof(side) === 'object' && ('title' in side || 'subTitle' in side));
};